export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    properties: {
      id: {
        type: 'string'
      },
      position: {
        title: 'Position',
        type: 'string'
      },
      startMonth: {
        title: 'Month',
        type: 'string',
        enum: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        enumNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      },
      startDay: {
        title: 'Day',
        type: 'integer',
        minimum: 1,
        maximum: 31
      },
      startYear: {
        title: 'Year',
        type: 'integer',
        minimum: 1900,
        maximum: 2100
      },
      endMonth: {
        title: 'Month',
        type: 'string',
        enum: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        enumNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      },
      endDay: {
        title: 'Day',
        type: 'integer',
        minimum: 1,
        maximum: 31
      },
      endYear: {
        title: 'Year',
        type: 'integer',
        minimum: 1900,
        maximum: 2100
      },
      description: {
        title: 'Description',
        type: 'string',
        maxLength: 20000
      }
    }
  },
  uiSchema: {
    group_pastPosition: {
      'ui:title': {
        text: '<b>Past Position</b>',
        escape: false
      }
    },
    position: {
      'ui:widget': 'text'
    },
    group_dateRange: {
      'ui:title': {
        text: '<b>Date Range</b>',
        escape: false
      }
    },
    groupInstructions: {
      'ui:title': 'Note: For activities that are/were only on one day, leave the start date blank and specify the end date. For activities that you started but have not yet presently completed, specify the start date and leave the end date blank.'
    },
    group_startDate: {
      'ui:title': 'Start Date',
      'ui:options': {
        compact: true
      }
    },
    startMonth: {
      'ui:widget': 'select'
    },
    startDay: {
      'ui:widget': 'text'
    },
    startComma: {
      'ui:title': ','
    },
    startYear: {
      'ui:widget': 'text'
    },
    group_endDate: {
      'ui:title': 'End Date',
      'ui:options': {
        compact: true
      }
    },
    endMonth: {
      'ui:widget': 'select'
    },
    endDay: {
      'ui:widget': 'text'
    },
    endComma: {
      'ui:title': ','
    },
    endYear: {
      'ui:widget': 'text'
    },
    description: {
      'ui:widget': 'richtext'
    },
    'dm:layout': [{
      id: 'group_pastPosition',
      type: 'group',
      children: [{
        id: 'position',
        type: 'field'
      }, {
        id: 'group_dateRange',
        type: 'group',
        children: [{
          id: 'groupInstructions',
          type: 'text'
        }, {
          id: 'group_startDate',
          type: 'group',
          children: [{
            type: 'field',
            id: 'startMonth'
          }, {
            type: 'field',
            id: 'startDay'
          }, {
            type: 'text',
            id: 'startComma'
          }, {
            type: 'field',
            id: 'startYear'
          }]
        }, {
          id: 'group_endDate',
          type: 'group',
          children: [{
            type: 'field',
            id: 'endMonth'
          }, {
            type: 'field',
            id: 'endDay'
          }, {
            type: 'text',
            id: 'endComma'
          }, {
            type: 'field',
            id: 'endYear'
          }]
        }]
      }, {
        id: 'description',
        type: 'field'
      }]
    }]
  },
  formData: {}
};